import { employeeActionSelectors as selector } from "../Selectors/index";

export const employeeReducer = (state = [], { type, payload }) => {
  switch (type) {
    case selector.GET:
      return payload;

    default:
      return state;
  }
};
